import api from "../../Api/feathers-client";
import { convertMinToSecond } from "../../Js/TimeAndDate";

// Call backend service to get all users
export const fetchUserByClass = async (params) => {
  // fetch user's by it's uids
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("users").find(params);
      resolve({
        status: 200,
        message: "Get User",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get all pod-class
export const getPodcastList = async (
  site_uuid,
  categoryArr,
  skip,
  limit,
  query = {}
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const DAY_MS =
        24 * 60 * 60 * 1000 * process.env.REACT_APP_BROADCAST_VALIDITY_DAYS;
      console.log("categoryArr", categoryArr);
      let response = await api.service("pod-class").find({
        query: {
          //...query,
          site_uuid: site_uuid,
          is_approved: true,
          is_deleted: false,
          context: {
            category: {
              $in: categoryArr,
            },
          },
          updatedAt: {
            $gt: new Date().getTime() - DAY_MS,
          },
          $sort: {
            updated_at: -1,
          },
          // $skip: skip,
          // $limit: limit,
        },
      });

      resolve({
        status: 200,
        message: "All podclass",
        data: response,
      });
    } catch (error) {
      console.log("SSS", error);
      resolve(error);
    }
  });
};

// Call backend service to get selected podcast
export const getPodcastInfo = async (uid, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("pod-class").find({
        query: {
          uid: uid,
          site_uuid: site_uuid,
          is_deleted: false,
        },
      });

      resolve({
        status: 200,
        message: "All podclass",
        data: response["data"],
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get selected podcast learners
export const getPodcastLearners = async (
  learner_ids,
  site_uuid,
  status = [true]
) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("users").find({
        query: {
          $select: [
            "uid",
            "name",
            "role_uid",
            "avatar",
            "belongs_to",
            "roll_no",
            "status",
          ],
          status: status,
          uid: {
            $in: learner_ids,
          },
          site_uuid: site_uuid,
          $limit: -1,
        },
      });

      resolve({
        status: 200,
        message: "All Learners",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to update assignment
export const updatePodcast = async (data, uid, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("pod-class").patch(null, data, {
        query: {
          uid,
          site_uuid,
        },
      });

      resolve({
        status: 200,
        message: "Podclass Updated",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get pending for approval podcast
export const getPendingApprovalPodcastInfo = async (user_uid, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("pod-class").find({
        query: {
          verb: "newsPodcast",
          approval_by: user_uid,
          is_approved: false,
          outcome: {
            filename: {
              $ne: null,
            },
            approvalStatus: null,
          },
          site_uuid: site_uuid,
          is_deleted: false,
          $sort: {
            updated_at: -1,
          },
        },
      });
      console.log("response", response);
      resolve({
        status: 200,
        message: "All podclass",
        data: response["data"],
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to move audio
export const moveUprovedBroadcast = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("approved-broadcast").create(data, {});
      resolve({
        status: 200,
        message: "Approved broadcast moved",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to move audio
export const removeBroadcastAudio = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("approved-broadcast").remove("", {
        query: data,
      });
      resolve({
        status: 200,
        message: "Rejected broadcast removed",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};
